import { Component, OnInit } from '@angular/core';
import { DataListFilterColumn, Datalistviewcolumn, DeviceIconcolumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';
import { StructureViewerLayer } from 'src/app/shared/structureviewermaps/structureviewerlayers';


@Component({
    selector: 'app-lanes',
    templateUrl: './lanes.component.html',
    styleUrls: ['./lanes.component.scss'],
    standalone: false
})
export class LanesComponent implements OnInit {

  constructor() { }

  public Columns: Array<Datalistviewcolumn> = [
    new Datalistviewcolumn("ID", "Id"),
    new DataListFilterColumn("Name", "Name", true, "Name"),
    new Datalistviewcolumn("Direction", "Direction"),
    new DataListFilterColumn("Gate", "GateName", true, "Gate.Name"),
    new DataListFilterColumn("Level", "GateParkingLevelName", true, "Gate.ParkingLevel.Name"),
    new DataListFilterColumn("Parking Lot", "GateParkingLevelParkingLotName", true, 'Gate.ParkingLevel.ParkingLot.Name'),
  ];

  public StructureViewerLayers: StructureViewerLayer[] = [new StructureViewerLayer("ParkingLot"), new StructureViewerLayer("Lane")]
  ngOnInit(): void {
  }

}
